import type { BadgeProps } from './Badge';

// Status badge helper
export function getStatusBadgeVariant(
  status: string
): BadgeProps['variant'] {
  switch (status) {
    case 'completed':
    case 'published':
    case 'success':
      return 'success';
    case 'pending':
    case 'draft':
    case 'processing':
      return 'warning';
    case 'failed':
    case 'cancelled':
    case 'error':
      return 'danger';
    case 'in_progress':
    case 'active':
      return 'info';
    default:
      return 'default';
  }
}
